import { ServicesContainer } from "utility/connections";

import redirectToAWSConnectPage from "./source/aws/connect_handler";
import AWSCoverImage from "./source/aws/CoverImage";
import redirectToAzureConnectPage from "./source/azure_sp/connect_handler";
import AzureCoverImage from "./source/azure_sp/CoverImage";
import redirectToBoxOauthUrl from "./source/box/connect_handler";
import BoxCoverImage from "./source/box/CoverImage";
import redirectToGCPConnectPage from "./source/gcp/connect_handler";
import GCPCoverImage from "./source/gcp/CoverImage";
import redirectToGithubOauthUrl from "./source/github/connect_handler";
import GithubCoverImage from "./source/github/CoverImage";
import redirectToGoogleConnectPage from "./source/google/connect_handler";
import GoogleCoverImage from "./source/google/CoverImage";
import GoogleConnectedExtraDetails from "./source/google/extra_details";
import redirectToM365OauthUrl from "./source/m365/connect_handler";
import M365CoverImage from "./source/m365/CoverImage";
import redirectToOktaConnectPage from "./source/okta/connect_handler";
import OktaCoverImage from "./source/okta/CoverImage";

// -----------------------------------------------------------------------------

const ExternalSources: ServicesContainer = {
  featured: "github",
  importanceOrder: [
    ["aws", "aws_key", "aws_role", "fixit_aws_role", "fixit_aws_key"],
    ["gcp", "gcp_resource_id"],
    ["google"],
    ["github"],
    ["okta", "okta_app"],
    ["m365"],
    ["azure_sp"],
    ["box"],
  ],
  services: [
    {
      name: "aws",
      alternativeNames: [
        "aws_key",
        "aws_role",
        "fixit_aws_role",
        "fixit_aws_key",
      ],
      label: "Amazon Web Services",
      coverImage: AWSCoverImage,
      onConnect: redirectToAWSConnectPage,
      searchTerms: ["aws", "amazon", "aws-account"],
    },
    {
      name: "gcp",
      alternativeNames: ["gcp_resource_id"],
      label: "Google Cloud Platform",
      coverImage: GCPCoverImage,
      onConnect: redirectToGCPConnectPage,
      searchTerms: ["gcp", "google", "cloud"],
    },
    {
      name: "github",
      label: "GitHub",
      coverImage: GithubCoverImage,
      onConnect: redirectToGithubOauthUrl,
      searchTerms: [],
    },
    {
      name: "google",
      label: "Google Workspace",
      coverImage: GoogleCoverImage,
      onConnect: redirectToGoogleConnectPage,
      onPostOauthConnect: redirectToGoogleConnectPage,
      onExtraDetails: GoogleConnectedExtraDetails,
      searchTerms: [],
    },
    {
      name: "okta",
      alternativeNames: ["okta_app"],
      label: "Okta",
      coverImage: OktaCoverImage,
      onConnect: redirectToOktaConnectPage,
      searchTerms: [],
    },
    {
      name: "m365",
      label: "Microsoft 365",
      coverImage: M365CoverImage,
      onConnect: redirectToM365OauthUrl,
      searchTerms: ["m365", "microsoft 365", "office 365"],
    },
    {
      name: "azure_sp",
      label: "Microsoft Azure",
      coverImage: AzureCoverImage,
      onConnect: redirectToAzureConnectPage,
      searchTerms: ["azure", "microsoft azure"],
    },
    {
      name: "box",
      label: "Box",
      coverImage: BoxCoverImage,
      onConnect: redirectToBoxOauthUrl,
      searchTerms: ["box"],
    },
  ],
};

export default ExternalSources;
